import { Rule } from 'antd/lib/form';
import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Input } from 'antd';
import { NamePath } from '~/utils/buildNamePath';
import emiratesIdValidation from '~/utils/emiratesIdValidation';
import { EmiratesIdInput, Form } from '..';

interface Props {
  name: NamePath;
  label?: string;
  disabled?: boolean;
  rules?: Rule[];
  [itemProps: string]: any;
  isRequired: boolean;
}

const EmiratesIdFormInput: FC<Props> = (props) => {
  const { name, label, disabled, rules, isRequired,  ...itemProps } = props;
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const errorMessages = form.getFieldError(name);

  // Check if there are any error messages
  const hasErrors = errorMessages.length > 0;

  return (
    <Form.Item
      name={name}
      rules={[{ validator: emiratesIdValidation } , { required: isRequired} ]}
      {...itemProps}
      label={label ?? t('Emirates Id')}
      // help={!hasErrors && <HelpText text={t('For Example: 784-1990-123456-7')}/>}
    >
      <EmiratesIdInput />
    </Form.Item>
  );
};

const HelpText = (props: any) => {
  const { text } = props;
  return <span>{text}</span>;
};

export default EmiratesIdFormInput;
